import moment, { Moment } from 'moment-timezone'

// Every filter query param used by any of the three tabs. Cleared on tab switch
// so a newly-opened tab never inherits the previous tab's filters.
export const FILTER_PARAM_KEYS = [
  'grouping',
  'search_attribute',
  'search_value',
  'page',
  'time_from',
  'time_until',
  'time_period',
  'anchor',
  'filter',
  'feeder_slot',
  'outcome',
  'deviation',
  'dosing_type',
  'product_category_id',
  'hour_from',
  'hour_to',
  'min_amount',
  'max_amount',
  'min_cycle_seconds'
]

export const getParam = (key: string): string | null =>
  new URLSearchParams(window.location.search).get(key)

// Sets each non-empty value and deletes keys whose value is null/empty, then
// writes the URL via push (navigation-worthy, e.g. tab switch) or replace
// (incidental, e.g. a filter change). No-ops when the URL would not change.
export const applyParams = (params: Record<string, string | null>, mode: 'push' | 'replace'): void => {
  const url = new URL(window.location.href)
  const before = url.toString()

  Object.entries(params).forEach(([key, value]) => {
    if (value === null || value === '') {
      url.searchParams.delete(key)
    } else {
      url.searchParams.set(key, value)
    }
  })

  if (url.toString() === before) return

  if (mode === 'push') {
    window.history.pushState(null, '', url.toString())
  } else {
    window.history.replaceState(null, '', url.toString())
  }
}

export const parseIsoParam = (value: string | null): Moment | null => {
  if (!value) return null

  const parsed = moment(value, moment.ISO_8601, true)
  return parsed.isValid() ? parsed : null
}

// Parses a 1-based page param, falling back to 1 for missing/invalid/<1 values.
export const parsePageParam = (value: string | null): number => {
  const page = parseInt(value || '', 10)
  return Number.isNaN(page) || page < 1 ? 1 : page
}
